import styled, { keyframes } from 'styled-components';
import Circle from './circle.svg';

const rotate = keyframes`
    100% {
        transform: rotate(360deg);
    }
`;

const dash = keyframes`
    0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
    }

    50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
    }

    100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
    }
`;

const color = keyframes`
    100%,
    0% {
        stroke: var(--colors-primary-blue-4);
    }

    40% {
        stroke: var(--colors-primary-blue-6);
    }

    66% {
        stroke: var(--colors-primary-blue-2);
    }

    80%,
    90% {
        stroke: #f1a426;
    }
`;

const AnimatedCircle = styled(Circle)`
  animation: ${rotate} 2s linear infinite;

  & > circle {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: ${dash} 1.5s ease-in-out infinite,
      ${color} 6s ease-in-out infinite;
    stroke-linecap: round;
    stroke-width: 1.5;
    stroke-miterlimit: 10;
  }
`;

export default AnimatedCircle;
